import {MainRequest} from 'Services/common';
import {Mcp} from '../../service';

const UrlMap = {
    list: '/aichat/mcp/function/args',
    edit: '/aichat/mcp/function/args/saves',
    remove: '/aichat/mcp/function/args/del',
};
export class McpFunctionArgs {
    static list(params: McpFunctionArgs.QueryList) {
        return MainRequest.get<SuccessData<McpFunctionArgs.List[]>>(
            `${UrlMap.list}/${params?.funcId}`,
            {
                params,
            },
        ).then(res => res.data.data);
    }

    static async save(data: McpFunctionArgs.Form) {
        return MainRequest.post(
            `${UrlMap.edit}/${data?.functionId}`,
            data?.formData,
        );
    }

    static async remove(id: string) {
        return MainRequest.get(`${UrlMap.remove}/${id}`);
    }

    static HiddenOptions = [
        {
            label: '普通参数',
            value: 1,
        },
        {
            label: '隐藏参数',
            value: 99,
        },
    ];
}

export namespace McpFunctionArgs {
    export type QueryForm = {};

    export interface Schema {
        id?: string;
        name: string; //        参数名称
        type: typeof Mcp.FieldType; //        参数类型：str, int, float, bool, json
        description: string; //        参数描述
        sendPosition: typeof Mcp.HttpPosition; //        发送位置：query, header, body, path
        example: string; //        示例值
        required: boolean; //        是否必填：0-否，1-是
        defaultValue: string; //        默认值
        hidden: string; //        是否隐藏：1-普通参数，99-隐藏参数
        sortOrder: number; //        排序顺序
    }

    export interface List extends Schema {}

    export interface Form {
        formData: Schema[];
        functionId: string;
    }

    export type QueryList = QueryForm & {funcId: string};
}
